// extracted by mini-css-extract-plugin
export default {"logoContainer":"logocontainer_logoContainer__Z-YNL","actionButton":"logocontainer_actionButton__zjIY7","logo":"logocontainer_logo__vIVke","pracsite":"logocontainer_pracsite__5yhMR"};